import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { CaseFormsService } from '../case-forms.service';
import { Globals } from '../../../globals';
import { MessagingService } from '../../../services/messaging.service';
import { Router } from '@angular/router';
import { ARService } from '../../ar/ar.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CaseAddProcedureComponent } from '../case-add-procedure/case-add-procedure.component';
import { CreateTransactionItemModel } from '../../../models/accountsReceivable/create-transaction-item.model';
import { DataPatientCaseWorkItemModel } from '../../../models/accountsReceivable/data-patient-case-work-item.model';
import { DataPatientCaseWorkItemToothModel } from '../../../models/teeth/data-patient-case-work-item-tooth.model';
import { EnumValidValueItemModel } from '../../../models/enum/enum-valid-value-item.model';
import { StaticDataService } from '../../../services/static-data.service';
import { CaseWorkItemStatusEnum } from '../../../models/enum/case-work-item-status.enum';
import { DataPatientCaseWorkItemFormToothModel } from '../../../models/teeth/data-patient-case-work-item-form-tooth.model';
import { CaseItemFormRemoveCancelComponent } from '../case-item-form-remove-cancel/case-item-form-remove-cancel.component';
import { CaseProcedureAddFormComponent } from '../case-procedure-add-form/case-procedure-add-form.component';
import { ToothPickerComponent } from '../../tdo-shared/tooth-picker/tooth-picker.component';
import { cfgTooth } from '../../tdo-shared/tooth-picker/tooth-picker.models';
import { ToothUiManagerModel } from '../../tdo-shared/tooth-picker/tooth-ui-manager/tooth-ui-manager.model';
import { PatientCaseWorkItemFormDataModel } from '../../../models/forms/data/patient-case-work-item-form-data.model';
import { NotesService } from '../../../services/notes.service';
import { TdoNoteQueryModel } from '../../../main-interface/controls/tdo-notes/models/tdo-note-query.model';
import { MessagingConstants } from '../../../models/MessagingConstants';
import { DoctorByTDOCIDModel } from '../../ar/models/doctor-by-tdocid.model';
import { PassedPatientCaseWorkItemEventModel } from '../models/passed-patient-case-work-item-event';
import { DataPatientCaseWorkItemEventModel } from '../../../models/accountsReceivable/data-patient-case-work-item-event';
import { LocalStorageService } from '../../../services/local-storage.service';
import { ToothService } from '../../../services/tooth.service';
import { UiService } from '../../../services/ui.service';
import { AuthenticationService } from '../../auth/services/authentication.service';
import { UserRoleEnum } from '../../../models/enum/user-role.enum';
import { ToothPickerConfigModel } from '../../tdo-shared/tooth-picker/tooth-picker-config.model';
import { ToothConfigurationModel } from '../../../models/teeth/tooth-configuration.model';
import { TdoDropdownChange } from '../../../tdo-controls/common/tdo-dropdown-v2/models/tdo-dropdown-change';
import { SchedulingService } from '../../scheduling/scheduling.service';
import { DataAppointmentModel } from '../../../models/appointments/data-appointment.model';
import { SignalrService } from '../../../services/socket/signalr.service';
import {
  CaseViewWorkItemEventsDialogComponent
} from './dialog/case-view-work-item-events-dialog/case-view-work-item-events-dialog.component';
import {
  CaseViewPatientFormsDetailsDialogComponent
} from './dialog/case-view-patient-forms-details-dialog/case-view-patient-forms-details-dialog.component';
import { DialogService } from '../../../services/dialog.service';
import { FormsGlobals } from 'src/app/models/forms/forms.enum';
import { Constants } from 'src/app/constants';
import { CaseBillFunctionalityComponent } from '../case-bill-functionality/case-bill-functionality.component';


@Component({
  selector: 'app-case-view',
  templateUrl: './case-view.component.html',
  styleUrls: ['./case-view.component.scss']
})
export class CaseViewComponent implements OnInit, OnDestroy {
  currentCaseWorkItem: DataPatientCaseWorkItemModel;
  currentCaseWorkItemForm: PatientCaseWorkItemFormDataModel;
  private _patientCaseId: string;
  private _isMinimizedByCheckOut: boolean;

  get patientCaseId(): string {
    return this._patientCaseId;
  }
  @Input()
  set patientCaseId(val: string) {
    if (this._patientCaseId !== val) {
      this._patientCaseId = val;
      this.currentPatientCaseId = val;
      this.currentSelection = '';
      if (val != null && val != undefined && val != 'null' && val != 'undefined')
        this.loadData(false);
      else{
        this.caseWorkItems = [];
        this.caseWorkItemsPatientForms=[];        
      }
    }
  }
  get isMinimizedByCheckOut(): boolean {
    return this._isMinimizedByCheckOut;
  }
  @Input()
  set isMinimizedByCheckOut(val: boolean) {
    if (this._isMinimizedByCheckOut !== val) {
      this._isMinimizedByCheckOut = val;
    }
  }

  @Output() requestCheckOut = new EventEmitter();



  subscription: any;

  enumCaseItemStatus: EnumValidValueItemModel[] = [];
  enumCaseItemFormStatus: EnumValidValueItemModel[] = [];
  enumCaseItemFormFilledBy: EnumValidValueItemModel[];
  allTeeth: cfgTooth[] = [];
  isLoading: boolean = true;
  isDataLoadingLoop: boolean = false;
  isLoadingPatientForms: boolean = true;
  caseWorkItems: DataPatientCaseWorkItemModel[];
  caseWorkItemsPatientForms: PatientCaseWorkItemFormDataModel[] = [];
  caseWorkItemsPatientFormsCaseWorkItemID: string;
  caseWorkItemsPatientFormsCaseWorkItem: DataPatientCaseWorkItemModel;
  appointment: DataAppointmentModel;
  currentCaseWorkItemID: string;
  currentCaseWorkItemFormID: string;
  currentSelection: string;
  allowToothPicker: boolean = false;
  currentSectionSelection: number = 1; // initially set to procedures section
  doctorsByTDOCID: DoctorByTDOCIDModel[] = [];
  activeDoctors: DoctorByTDOCIDModel[] = [];
  locationDoctors: DoctorByTDOCIDModel[] = [];

  caseWorkItemStatusPending = '00000167-1000-0000-0000-000000000001';
  caseWorkItemStatusComplete = '00000167-1000-0000-0000-000000000003';
  caseWorkItemStatusCancelled = '00000167-1000-0000-0000-000000000004';
  caseWorkItemStatusInProgress = '00000167-1000-0000-0000-000000000002';

  currentPatientCaseId: string;
  errors: any;
  messageSubscription: any;
  userIsDoctor: boolean = false;

  patientFormsMessage = 'No general forms added.';
  isShowPatientForms: boolean = false;
  isReloadingForms: boolean = false;

  showMoreCaseOptions: boolean = false;
  listOfMoreCaseOptions = [
    { name: 'Complete Case', id: 0 }, // just complete case
    { name: 'Bill', id: 1 }, // complete case first, then go to fees
    { name: 'Check Out', id: 2 }, // placehold for moises checkout component
  ];

  dataLoaded: boolean = false; //flag to wait for  collections loading before executing loadData() (this is causing things like doctor selection being empty because collection hastn't been loaded)
  constructor(
    private readonly signalrService: SignalrService,
    public globals: Globals,
    private readonly caseService: CaseFormsService,
    private readonly messagingService: MessagingService,
    private readonly router: Router,
    private readonly arService: ARService,
    private readonly snackBar: MatSnackBar,
    private readonly dialog: MatDialog,
    private readonly staticDataService: StaticDataService,
    private readonly notesService: NotesService,
    private readonly localStorageService: LocalStorageService,
    private readonly toothService: ToothService,
    public uiService: UiService,
    private readonly authenticationService: AuthenticationService,
    private readonly schedulingService: SchedulingService,
    private readonly dialogService: DialogService,
    public formsGlobals: FormsGlobals
  ) { }

  private setEnums() {
    this.enumCaseItemStatus = this.staticDataService.getValidValueItemsByValidValueName('enumCaseWorkItemStatus');
    this.enumCaseItemFormStatus = this.staticDataService.getValidValueItemsByValidValueName('enumFormCompletionStatus');
    this.enumCaseItemFormFilledBy = this.staticDataService.getValidValueItemsByValidValueName('enumFormFilledBy');
    this.loadInitialData();
  }

  async ngOnDestroy() { 
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = false;
    }
  }
  async ngOnInit() {
    console.log('CaseViewComponent ngOnInit');
    console.log('CaseViewComponent ngOnInit: this.staticDataService.isReady', this.staticDataService.isReady);
    if (this.staticDataService.isReady) {
      this.setEnums();
    } 
    else {
      console.log('CaseViewComponent ngOnInit: this.staticDataService.isReady is not ready, validvalues:', this.staticDataService.validValues);
      if (!this.staticDataService.validValues) {
        this.staticDataService.refreshValues();
      }
      this.staticDataService.validValuesReadyEvent.subscribe({
        complete: () => {
          this.setEnums();
        }
      });

      this.signalrService.messageUser.subscribe((message) => {
        switch (message.messageType) {
          case 'PATIENT_FORMS_CREATION_START':
            break;
          case 'PATIENT_FORMS_CREATED':
            break;
          case MessagingConstants.CASES_REFRESH:
            this.loadData(false);
            break;
        }
      });
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = false;
    }

    this.subscription = this.messagingService.componentMessageCall.subscribe((response) => {
      const event = response.event;
      switch (event) {
        case MessagingConstants.CASES_REFRESH:
          this.loadData(false);
          break;
        case MessagingConstants.CASE_FORMS_REFRESH:
        case MessagingConstants.CASE_CHANGED_EVENT:
        case MessagingConstants.RELOAD_PATIENT_FORMS:
          if (!this.isDataLoadingLoop)
            this.reloadPatientForms();
          else
            console.log('case view init component message call reloadPatientForms isDataLoadingLoop');
          break;
        case MessagingConstants.CASE_VIEW_COLLAPSE:
          break;
        case MessagingConstants.CHECKOUT_PATIENT_START:
          this.onCheckOutPatient();
      }
    });


  }

  async loadInitialData() {
    // get all enums
    console.log('CaseViewComponent loadInitialData: ', this.globals.ThePatient, this.globals.currentPatientId);
    this.globals.currentPatientId = this.globals.ThePatient?.PatientId;
    if (this.globals.currentPatientId !== 'null' && this.globals.currentPatientId !== 'undefined' && this.globals.currentPatientId !== null && this.globals.currentPatientId !== undefined) {
      const promises: any[] = [
        this.caseService.getTeeth('00000091-1000-0000-0000-000000000001').toPromise(), // US tooth grouping
        this.arService.getDoctorsByTDOCIDFees().toPromise(),
        this.caseService.getPatientFormsCaseWorkItem(this.globals.LOCID, this.globals.currentPatientId).toPromise(), // general patient forms caseWorkItem
        this.arService.getDoctorsByLOCID(parseInt(this.globals.LOCID)).toPromise(), // Location doctors
      ];


      try {
        console.log('CaseViewComponent loadInitialData: promises', promises); 
        Promise.all(promises).then((results) => {
          console.log('CaseViewComponent loadInitialData: results', results); 
          this.allTeeth = results[0];
          if (results[1]) {
            this.doctorsByTDOCID = results[1];
            this.activeDoctors = this.doctorsByTDOCID.filter(p => p.isActiveDoctor);
          }
          if (results[2]) {
            this.caseWorkItemsPatientFormsCaseWorkItem = results[2];
            this.caseWorkItemsPatientFormsCaseWorkItemID = this.caseWorkItemsPatientFormsCaseWorkItem?.CaseWorkItemId;
          }
          if (results[3]) {
            this.locationDoctors = results[3];
          }
          this.dataLoaded = true;
          // is user a doctor?
          const userId = this.localStorageService.currentUserData.authdata.userid;
          const userDoctor = this.doctorsByTDOCID.find(a => a.UserId === userId);
          if (userDoctor) {
            this.userIsDoctor = true;
          }
          this.isLoading = false;
          this.isLoadingPatientForms = false;
        }).catch((err) => {
          console.log('loading forms promise errror', err);
          this.isLoading = false;
          this.isLoadingPatientForms = false;
          this.showMessage('Something went wrong', 'Error');
        });
      }
      catch (err) {
        console.log('loading forms errror', err);
        this.isLoading = false;
        this.isLoadingPatientForms = false;
        this.showMessage('Something went wrong', 'Error');
      }
    }
    else {
      this.isLoadingPatientForms = false;
      this.isLoading = false;
    }
  }

  async reloadPatientForms() {
    if (this.isReloadingForms){
      console.log('case view init reload patient forms already reloading');
      return;
    }
    this.isReloadingForms = true;
    this.isLoadingPatientForms = true;
    this.caseWorkItemsPatientForms = [];
    this.caseWorkItemsPatientFormsCaseWorkItemID = '';

    const promises: any[] = [
      this.caseService.getPatientForms(this.globals.currentPatientId).toPromise(), // general patient forms
      this.caseService.getPatientFormsCaseWorkItemID(this.globals.LOCID, this.globals.currentPatientId).toPromise() // general patient forms caseWorkItemID
    ];

    try {
      const results: any[] = await Promise.all(promises);

      if (results[0]) {
        const patientForms = results[0].sort((a, b) => {
          return a.formOrder - b.formOrder;
        });;
        this.caseWorkItemsPatientForms = patientForms;
      }

      if (results[1]) {
        this.caseWorkItemsPatientFormsCaseWorkItemID = results[1];
      }

      this.isLoading = false;
      this.isLoadingPatientForms = false;
      this.isLoading = false;
      this.isReloadingForms = false;
    } catch (err) {
      console.log('case view init forms reload error');
      this.isLoading = false;
      this.isLoadingPatientForms = false;
      this.isReloadingForms = false;
      this.showMessage('Something went wrong', 'Error');
    }
  }

  isCurrentSelection(CaseWorkItemId: string, CaseWorkItemFormsId: string) {
    if (CaseWorkItemId && CaseWorkItemId === this.currentCaseWorkItemID) {
      return true;
    }
    else if (CaseWorkItemFormsId && CaseWorkItemFormsId === this.currentSelection) {
      return true;
    }
    else {
      return false;
    }
  }

  setCurrentSelections(CaseWorkItemId: string, CaseWorkItemFormsId: string, loadNotes: boolean = true) {
    this.currentCaseWorkItem = this.caseWorkItems.find(p => p.CaseWorkItemId === CaseWorkItemId);
    if (this.currentCaseWorkItem !== undefined) {
      this.currentCaseWorkItemForm = this.currentCaseWorkItem.dataPatientCaseItemForms.find(p => p.CaseWorkItemFormsId.toLowerCase() === CaseWorkItemFormsId.toLowerCase());
    }
    this.currentCaseWorkItemFormID = CaseWorkItemFormsId;
    this.currentCaseWorkItemID = CaseWorkItemId;
    this.globals.currentPatientCaseWorkItemID = this.currentCaseWorkItemID;

    if (CaseWorkItemFormsId) {
      this.currentSelection = CaseWorkItemFormsId;
    }
    else {
      this.currentSelection = CaseWorkItemId;
      if (loadNotes) {
        const noteQueryModel = new TdoNoteQueryModel();
        noteQueryModel.parentObjectName = 'dataPatientCaseWorkItem';
        noteQueryModel.objectId = CaseWorkItemId;
        noteQueryModel.patientId = this.globals.currentPatientId;
        this.notesService.changeNoteQuery(noteQueryModel);
      }
    }

    // update toothpicker active status
    this.setTootPickerStatus();

    // send message to fees page that new case work item was selected
    // get caseworkitem by caseworkitemid
    this.messagingService.sendComponentMessage(MessagingConstants.CASE_VIEW_ITEM_CHANGED_EVENT, { doctorId: this.currentCaseWorkItem?.ProviderDoctorID });
  }

  returnFormCompletionStatusByIcon(form: PatientCaseWorkItemFormDataModel, todo: number) {
    let statusIcon = '';
    let description = '';
    let returnString = '';

    if (form.isSigned) {
      returnString = 'assets/icons/icons8-signature-48.png';
    }
    else {
      this.enumCaseItemFormStatus.forEach(a => {
        if (a.ValidValueItemId === form.enumFormCompletionStatusID) {
          statusIcon = a.IconIDSVG;
          description = a.ItemDisplayValue;
        }
      });

      if (todo === 1) {
        returnString = 'assets/Images/Calendar/' + statusIcon;
      }
      else {
        returnString = description;
      }
    }
    //TODO: This is called thousands of times, check logic to avoid cycling
    //console.log("returnFormCompletionStatusByIcon", returnString);
    return returnString;
  }

  returnFormCompletionDate(enumFormCompletionStatusID: string, statusOn: Date) {
    if (enumFormCompletionStatusID === null) {
      return '';
    }
    else if (enumFormCompletionStatusID === this.formsGlobals.STATUS_COMPLETED || enumFormCompletionStatusID === this.formsGlobals.STATUS_COMPLETEDANDSIGNED) {
      return statusOn;
    }
    else {
      return '';
    }
  }

  returnFormFilledByIcon(enumFormFilledByID: string, todo: number) {
    let statusIcon = '';
    let description = '';
    let returnString = '';
    if (this.enumCaseItemFormFilledBy) {
      if (enumFormFilledByID) {
        var item = this.enumCaseItemFormFilledBy.find(a => a.ValidValueItemId === enumFormFilledByID);
        if (item) {
          statusIcon = item.IconIDSVG;
          description = item.ItemDisplayValue;
        }
      }
      else {
        // get 'any' icon
        var item = this.enumCaseItemFormFilledBy.find(a => a.ItemDisplayValue.toLowerCase() === 'any');
        if (item) {
          statusIcon = item.IconIDSVG;
          description = item.ItemDisplayValue;
        }
      }

      if (todo === 1) {
        returnString = statusIcon;
      }
      else {
        returnString = 'To be completed by: ' + description;
      }
    }
    return returnString;
  }

  returnFormFilledByIconPreload(enumFormFilledByID: string) {
    let statusIcon = '';
    let description = '';
    let returnStrings: string[] = [];

    if (this.enumCaseItemFormFilledBy) {
      if (enumFormFilledByID) {
        var item = this.enumCaseItemFormFilledBy.find(a => a.ValidValueItemId === enumFormFilledByID);
        if (item) {
          statusIcon = item.IconIDSVG;
          description = item.ItemDisplayValue;
        }
      }
      else {
        // get 'any' icon
        var item = this.enumCaseItemFormFilledBy.find(a => a.ItemDisplayValue.toLowerCase() === 'any');
        if (item) {
          statusIcon = item.IconIDSVG;
          description = item.ItemDisplayValue;
        }
      }

      returnStrings = [`To be completed by: ${description}`, statusIcon];
    }

    return returnStrings;
  }

  returnCaseStatusIcon(enumCaseWorkItemStatus: string, todo: number) {
    let statusIcon = '';
    let description = '';
    let returnString = '';

    if (enumCaseWorkItemStatus === CaseWorkItemStatusEnum.Completed) {
      statusIcon = 'check_circle';
      description = 'Completed';
    }
    else if (enumCaseWorkItemStatus === CaseWorkItemStatusEnum.Pending) {
      statusIcon = 'pending_actions';
      description = 'Pending';
    }
    else if (enumCaseWorkItemStatus === CaseWorkItemStatusEnum.Canceled) {
      statusIcon = 'not_interested';
      description = 'Canceled';
    }
    else if (enumCaseWorkItemStatus === CaseWorkItemStatusEnum.Hold) {
      statusIcon = 'pause_circle';
      description = 'On Hold';
    }
    else if (enumCaseWorkItemStatus === CaseWorkItemStatusEnum.InProgress) {
      statusIcon = 'loop';
      description = 'In Progress';
    }

    if (todo === 1) {
      returnString = statusIcon;
    }
    else {
      returnString = description;
    }

    return returnString;
  }

  updateItemStatus() {
    // update form and case status if necessary
    const form = this.returnSelectedCaseWorkItemForm();
    const item = this.returnSelectedCaseWorkItem();

    if (!form || !item) {
      return false;
    }

    if (form.enumFormCompletionStatusID === null) {
      form.enumFormCompletionStatusID = '';
    }

    if (item.enumCaseWorkItemStatusID === null) {
      item.enumCaseWorkItemStatusID = '';
    }

    if (form.enumFormCompletionStatusID === this.formsGlobals.STATUS_NOT_STARTED || item.enumCaseWorkItemStatusID === this.caseWorkItemStatusPending) {

      this.isLoading = true;

      if (form.enumFormCompletionStatusID === this.formsGlobals.STATUS_NOT_STARTED && item.enumCaseWorkItemStatusID === this.caseWorkItemStatusPending) {
        this.caseService.setCaseWorkItemAndFormToStarted(this.currentCaseWorkItemID, this.currentCaseWorkItemFormID)
          .subscribe((response: any) => {

            // update local status
            this.caseWorkItems.forEach(a => {
              if (a.CaseWorkItemId === this.currentCaseWorkItemID) {
                a.enumCaseWorkItemStatusID = this.caseWorkItemStatusInProgress;

                a.dataPatientCaseItemForms.forEach(b => {
                  if (b.CaseWorkItemFormsId === this.currentCaseWorkItemFormID) {
                    b.enumFormCompletionStatusID = this.formsGlobals.STATUS_STARTED; //this.formStatusStarted;
                  }
                });
              }
            });

          }, err => {
            this.showMessage('Error', 'Problem updating procedure and form status');
          });
      }
      else if (form.enumFormCompletionStatusID === this.formsGlobals.STATUS_NOT_STARTED) {//} this.formStatusNotStarted) {
        // api call to set Started status
        this.caseService.setCaseWorkItemFormToStarted(this.currentCaseWorkItemFormID)
          .subscribe((response: any) => {

            // update local status
            this.caseWorkItems.forEach(a => {
              if (a.CaseWorkItemId === this.currentCaseWorkItemID) {
                a.dataPatientCaseItemForms.forEach(b => {
                  if (b.CaseWorkItemFormsId === this.currentCaseWorkItemFormID) {
                    b.enumFormCompletionStatusID = this.formsGlobals.STATUS_STARTED;// this.formStatusStarted;
                  }
                });
              }
            });
          }, err => {
            this.showMessage('Error', 'Problem updating form status');
          });
      }
      else if (item.enumCaseWorkItemStatusID === this.caseWorkItemStatusPending) {
        // api call to set In Progress status
        this.caseService.setCaseWorkItemToInProgress(this.currentCaseWorkItemID)
          .subscribe((response: any) => {

            // update local status
            this.caseWorkItems.forEach(a => {
              if (a.CaseWorkItemId === this.currentCaseWorkItemID) {
                a.enumCaseWorkItemStatusID = this.caseWorkItemStatusInProgress;
              }
            });
          }, err => {
            this.showMessage('Error', 'Problem updating procedure status');
          });
      }
      this.isLoading = false;
    }
  }

  loadForm(caseWorkItemFormsId: string, EnumCustomFormId: string, form: PatientCaseWorkItemFormDataModel) {
    if (this.router.url !== '/landing/case-view') {
      this.router.navigateByUrl('/landing/case-view').then(() => {
        //
        setTimeout(() => {
          this.loadFormAfterRouteCheck(caseWorkItemFormsId, EnumCustomFormId, form);
        }, 100);
      });
    } else {
      this.loadFormAfterRouteCheck(caseWorkItemFormsId, EnumCustomFormId, form);
    }
    this.updateCaseStatus(caseWorkItemFormsId, form.CaseWorkItemId);
  }

  loadFormAfterRouteCheck(caseWorkItemFormsId: string, EnumCustomFormId: string, form: PatientCaseWorkItemFormDataModel) {
    // also pass in enumCustomFormID, and if form is custom then need to run appropriate component
    this.currentCaseWorkItem = this.caseWorkItems.find(p => p.CaseWorkItemId === form.CaseWorkItemId);
    this.globals.currentPatientCaseWorkItemFormsID = caseWorkItemFormsId;
    this.messagingService.sendComponentMessage(MessagingConstants.FORM_EDIT_START, {
      caseWorkItem: this.currentCaseWorkItem,
      CaseWorkItemFormsId: caseWorkItemFormsId,
      enumCustomFormId: EnumCustomFormId,
      form
    });

    if (caseWorkItemFormsId && !EnumCustomFormId) {
      const noteQueryModel = new TdoNoteQueryModel();
      noteQueryModel.parentObjectName = 'dataPatientCaseWorkItemForms';
      noteQueryModel.objectId = caseWorkItemFormsId;
      noteQueryModel.patientId = this.globals.currentPatientId;
      this.notesService.changeNoteQuery(noteQueryModel);
    }
  }

  updateCaseStatus(caseWorkItemFormsId: string, CaseWorkItemId: string) {
    this.caseService.updateCaseViewStatusByforms(caseWorkItemFormsId, CaseWorkItemId)
      .subscribe((response: any) => {
        if (response) {
          this.messagingService.sendComponentMessage(MessagingConstants.ONLY_CASES_STATUS_REFRESH, { PatientCaseId: this.globals.currentPatientCaseId });
        }
      });

  }

  returnToothList(teeth: DataPatientCaseWorkItemToothModel[]) {
    let list = '';

    let uniqueTeeth: string[] = [];
    for (const t of teeth) {
      if (!uniqueTeeth.includes(t.Notation)) {
        uniqueTeeth.push(t.Notation);
      }
    }

    /*uniqueTeeth = uniqueTeeth.sort((a, b) => {
      return b - a;
    });*/

    if (uniqueTeeth) {
      if (uniqueTeeth.length) {
        uniqueTeeth.forEach(a => {
          list += a + ', ';
        });

        // remove last comma
        list = list.slice(0, -2);
      }
    }

    return list;
  }

  returnToothListForForm(teeth: DataPatientCaseWorkItemFormToothModel[]) {
    let list = '';
    if (teeth) {
      if (teeth.length) {
        teeth.forEach(a => {
          list = list + a.Notation + ', ';
        });

        // remove last comma
        list = list.slice(0, -2);
      }
    }

    return list;
  }

  loadData(isOpenFirstForm: boolean = true, retryTimeout: boolean = false) {
    if (this.isDataLoadingLoop && !retryTimeout) {
      return;
    }
    this.isDataLoadingLoop = true;
    this.isLoading = true;
    if (!this.dataLoaded) {
      const ivl = setTimeout(() => {
        this.loadData(isOpenFirstForm, true);
      }, 200);
      return;
    }
    this.isDataLoadingLoop = false;
    // load patient forms list
    this.reloadPatientForms();

    if (this.currentPatientCaseId && this.currentPatientCaseId !== 'null') {
      this.caseWorkItems = [];
      this.caseService.getCaseWorkItemsByPatientCaseID(this.currentPatientCaseId).subscribe((data) => {
        this.caseWorkItems = data.map(caseWorkItem => ({ ...caseWorkItem, ProviderDoctor: this.returnLocationDoctorByContactID(caseWorkItem.ProviderDoctorContactID) }));
        let providerDoctorFromCases = null;
        for (const item of this.caseWorkItems) {
          for (const form of item.dataPatientCaseItemForms) {
            const iconInfo: string[] = this.returnFormFilledByIconPreload(form.enumFormFilledByID)
            form.formFilledIcon = iconInfo[1];
            form.formFilledTooltip = iconInfo[0];
          }
          if (item.ProviderDoctorID)
            providerDoctorFromCases = item.ProviderDoctor
        }
        if (providerDoctorFromCases)
          this.setActiveDoctor(providerDoctorFromCases, null, null, false);
        this.isLoading = false;

        // load first form
        if (data.length) {
          data.every(a => {
            if (a.dataPatientCaseItemForms) {
              if (a.dataPatientCaseItemForms.length) {
                if (a.dataPatientCaseItemForms[0].CaseWorkItemFormsId) {
                  if (isOpenFirstForm) {
                    this.updateItemStatus();
                  } else {
                    this.isLoading = false;
                  }
                  return false;
                }
              }
            }
            return true;
          });
        }
        this.isLoading = false;
        //this.subscription = false;
      },
        error => {
          this.errors = error;
          this.isLoading = false;
          //this.subscription = false;
        }
      );
    } else {
      this.caseWorkItems = [];
      this.isLoading = false;
    }
  }

  returnCurrentCaseProcedureName() {
    if (this.currentCaseWorkItemID) {
      const item: DataPatientCaseWorkItemModel[] = this.caseWorkItems.filter(i =>
        this.currentCaseWorkItemID.toLowerCase() === i.CaseWorkItemId.toLowerCase()
      );

      if (item.length) {
        return item[0].Description;
      } else {
        return '';
      }
    } else {
      return '';
    }
  }

  openDialogAddForm() {
    if ((this.currentSelection && this.currentSectionSelection === 1) || this.currentSectionSelection === 0) {
      // open a window to add a new procedure form to this case
      const dialogRef = this.dialog.open(CaseProcedureAddFormComponent, {
        panelClass: 'dialog',
        data: {
          CaseWorkItem: this.currentCaseWorkItem,
          CaseWorkItemID: this.currentCaseWorkItemID,
          CaseProcedureName: this.returnCurrentCaseProcedureName(),
          SelectionSection: this.currentSectionSelection,
          AddedGeneralPatientForms: this.caseWorkItemsPatientForms,
          LOCID: this.globals.LOCID,
          CaseWorkItemsPatientFormsCaseWorkItemID: this.caseWorkItemsPatientFormsCaseWorkItemID
        }
      });
      dialogRef.afterClosed().subscribe(result => {

        // if any forms need a tooth, then open the tooth selector
        // then, once tooth is selected, assign tooth to all forms that require a tooth and don't already have one
        if (result !== undefined && result !== true) {
          // filter forms that require a tooth
          const requiresTooth = result.filter(a => a.isToothRequired && a.isToothRequired === true);
          if (requiresTooth.length > 0) {

            // one or more forms require tooth
            // open tooth picker
            const toothConfig = new ToothPickerConfigModel();
            toothConfig.isMultiSelect = true;
            toothConfig.selectedTeeth = [];

            const dialogRefTooth = this.dialog.open(ToothPickerComponent, {
              panelClass: 'dialog',
              data: toothConfig
            });
            dialogRefTooth.afterClosed().subscribe(resultTooth => {

              // array of teeth
              const teeth: cfgTooth[] = [];
              const toothUI: ToothUiManagerModel[] = resultTooth;
              toothUI.forEach(a => {
                teeth.push(a.toothModel);
              });

              // add selected teeth to newly added forms that need them
              let CaseProcedureFormIDs = '';
              requiresTooth.forEach(required => {
                CaseProcedureFormIDs += required.CaseProcedureFormId + '_';
              });

              // add selected teeth to newly added forms that need them
              // this.caseService.setCaseWorkItemFormTeeth(this.currentCaseWorkItemID, this.currentCaseWorkItemFormID, teeth)
              this.caseService.setCaseWorkItemFormTeethAfterFormAddition(this.currentCaseWorkItemID, CaseProcedureFormIDs, teeth)
                .subscribe((response: any) => {
                  this.loadData();
                  this.showMessage('Success', 'Teeth updated for form');
                  this.toothService.notifyToothChange();
                }, err => {
                  this.showMessage('Error', 'Problem updating teeth for form');
                });

            }, err => {
              // this.loadData();
            });
          }
          else {
            // no tooth need forms
            this.loadData(false);
            //loaddata already reloads the forms
            //this.refreshPatientForms();
          }
        }
      }, err => {
        // this.loadData();
      });
    }
  }

  returnTeethForCurrentSelectedItem() {

    // get current case work item
    const caseWorkItem = this.returnSelectedCaseWorkItem();
    // const caseWorkItem: DataPatientCaseWorkItemModel[] = this.caseWorkItems.filter(a => a.CaseWorkItemId === this.currentCaseWorkItemID);
    const teeth: cfgTooth[] = [];

    if (caseWorkItem) {
      // case item or form
      if (this.currentSelection === this.currentCaseWorkItemID) {
        // case work item
        if (caseWorkItem.dataPatientCaseItemTeeth.length) {
          caseWorkItem.dataPatientCaseItemTeeth.forEach(a => {
            if (this.allTeeth.filter(x => x.ToothId === a.ToothID).length) {
              teeth.push(this.allTeeth.filter(x => x.ToothId === a.ToothID)[0]);
            }
          });
        }
      }
      else if (this.currentSelection === this.currentCaseWorkItemFormID) {

        // if general patient forms
        if (this.currentSectionSelection === 0) {
          const pForm = this.caseWorkItemsPatientForms.find(form => form.CaseWorkItemFormsId === this.currentCaseWorkItemFormID);
          if (pForm && pForm.dataPatientCaseItemFormTeeth) {
            pForm.dataPatientCaseItemFormTeeth.forEach(tooth => {
              const toothToPush = this.allTeeth.find(x1 => x1.ToothId === tooth.ToothID);
              if (toothToPush) {
                teeth.push(toothToPush);
              }
            });
          }
        }
        else {
          // case work item form
          const pForm = caseWorkItem.dataPatientCaseItemForms.find(form => form.CaseWorkItemFormsId === this.currentCaseWorkItemFormID);
          if (pForm && pForm.dataPatientCaseItemFormTeeth) {
            pForm.dataPatientCaseItemFormTeeth.forEach(tooth => {
              const toothToPush = this.allTeeth.find(x1 => x1.ToothId === tooth.ToothID);
              if (toothToPush) {
                teeth.push(toothToPush);
              }
            });
          }
        }
      }
    }

    return teeth;
  }

  openDialogEditTeeth() {
    if (this.currentSelection) {
      const toothConfig = new ToothPickerConfigModel();
      toothConfig.isMultiSelect = true;
      const teeeth: ToothConfigurationModel[] = [];
      const currentTeeth = this.returnTeethForCurrentSelectedItem();
      for (const tt of currentTeeth) {
        const toot = new ToothConfigurationModel();
        toot.ToothId = tt.ToothId;
        teeeth.push(toot);
      }
      toothConfig.selectedTeeth = teeeth;

      // open a window to add a new procedure form to this case
      const dialogRef = this.dialog.open(ToothPickerComponent, {
        panelClass: 'dialog',
        data: toothConfig
      });
      dialogRef.afterClosed().subscribe(result => {

        // array of teeth
        const teeth: cfgTooth[] = [];
        const toothUI: ToothUiManagerModel[] = result;
        toothUI.forEach(a => {
          teeth.push(a.toothModel);
        });

        if (this.currentSelection === this.currentCaseWorkItemID) {
          // CaseWorkItem
          this.caseService.setCaseWorkItemTeeth(this.currentCaseWorkItemID, teeth)
            .subscribe((response) => {
              this.loadData();
              this.showMessage('Success', 'Teeth updated for procedure');
              for (const res of response) {
                const uiTooth = toothUI.find(p => p.toothModel.ToothId === res.ToothID);
                if (uiTooth) {
                  this.caseService.saveCaseWorkItemTeethSurfaces(res.CaseWorkItemToothId, uiTooth.selectedSurfaceIds).subscribe((surfaceRes) => {
                    //
                  });
                }
              }
              this.toothService.notifyToothChange();
            }, err => {
              this.showMessage('Error', 'Problem updating teeth for procedure');
            });
        } else if (this.currentSelection === this.currentCaseWorkItemFormID) {
          // CaseWorkItemForm
          this.caseService.setCaseWorkItemFormTeeth(this.currentCaseWorkItemID, this.currentCaseWorkItemFormID, teeth)
            .subscribe((response) => {
              this.loadData();
              this.showMessage('Success', 'Teeth updated for form');
              for (const res of response) {
                const uiTooth = toothUI.find(p => p.toothModel.ToothId === res.ToothID);
                if (uiTooth) {
                  this.caseService.saveCaseWorkItemTeethSurfaces(res.CaseWorkItemToothId, uiTooth.selectedSurfaceIds).subscribe((surfaceRes) => {
                    //
                  });
                }
              }
              this.toothService.notifyToothChange();
            }, err => {
              this.showMessage('Error', 'Problem updating teeth for form');
            });
        }

      }, err => {
        // this.loadData();
      });
    }
  }

  returnSelectedCaseWorkItem() {
    let item: DataPatientCaseWorkItemModel = new DataPatientCaseWorkItemModel();
    if (this.currentSectionSelection === 1) {
      item = this.caseWorkItems.filter(a => a.CaseWorkItemId === this.currentCaseWorkItemID)[0];
    }
    else {
      item = this.caseWorkItemsPatientFormsCaseWorkItem;
    }
    return item;
  }

  returnSelectedCaseWorkItemForm() {
    const item = this.returnSelectedCaseWorkItem();
    let form: PatientCaseWorkItemFormDataModel = new PatientCaseWorkItemFormDataModel();
    if (this.currentSectionSelection === 1) {
      form = item.dataPatientCaseItemForms.filter(a => a.CaseWorkItemFormsId === this.currentCaseWorkItemFormID)[0];
    }
    else {
      form = this.caseWorkItemsPatientForms.filter(a => a.CaseWorkItemFormsId === this.currentCaseWorkItemFormID)[0];
    }
    return form;
    // return null;
  }

  setTootPickerStatus() {
    // first, make sure a selected has been made
    if (this.currentCaseWorkItemID) {

      this.allowToothPicker = false;

      // get statuses
      let EnumFormCompletionStatus = '';
      let EnumCaseWorkItemStatusID = '';
      if (this.currentCaseWorkItemFormID) {
        EnumFormCompletionStatus = this.returnSelectedCaseWorkItemForm()?.enumFormCompletionStatusID;
      }
      if (this.currentCaseWorkItemID) {
        EnumCaseWorkItemStatusID = this.returnSelectedCaseWorkItem()?.enumCaseWorkItemStatusID;
      }

      // check status
      if (this.currentSelection === this.currentCaseWorkItemFormID) {
        this.allowToothPicker = true;
        /*if (EnumFormCompletionStatus === this.formStatusNotStarted) {
          // allow tooth edit

        }*/
      }
      else if (this.currentSelection === this.currentCaseWorkItemID) {
        if (EnumCaseWorkItemStatusID !== this.caseWorkItemStatusComplete && EnumCaseWorkItemStatusID !== this.caseWorkItemStatusCancelled) {
          // allow tooth edit
          this.allowToothPicker = true;
        }
      }
    }
  }

  openDialogRemove() {

    // first, make sure a selected has been made
    if (this.currentSectionSelection === 0) {

      // get statuses for delete/cancel
      let EnumFormCompletionStatus = '';
      if (this.currentCaseWorkItemFormID) {
        this.caseWorkItemsPatientForms.forEach(a => {
          if (a.CaseWorkItemFormsId === this.currentCaseWorkItemFormID) {
            EnumFormCompletionStatus = a.enumFormCompletionStatusID;
          }
        });
      }

      const dialogRef = this.dialog.open(CaseItemFormRemoveCancelComponent, {
        panelClass: 'dialog',
        data: {
          CaseWorkItemID: this.caseWorkItemsPatientFormsCaseWorkItemID,
          CaseWorkItemFormID: this.currentCaseWorkItemFormID,
          enumFormCompletionStatus: EnumFormCompletionStatus,
          enumCaseWorkItemStatusID: ''
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result === 'delete') {
          this.deleteSelectedItem();
        }
        else if (result === 'cancel') {
          this.cancelSelectedItem();
        }
      });
    }
    else if (this.currentCaseWorkItemID) {

      // get statuses for delete/cancel
      let EnumFormCompletionStatus = '';
      let EnumCaseWorkItemStatusID = '';
      if (this.currentCaseWorkItemFormID) {
        EnumFormCompletionStatus = this.returnSelectedCaseWorkItemForm().enumFormCompletionStatusID;
      }
      if (this.currentCaseWorkItemID) {
        EnumCaseWorkItemStatusID = this.returnSelectedCaseWorkItem().enumCaseWorkItemStatusID;
      }

      const dialogRef = this.dialog.open(CaseItemFormRemoveCancelComponent, {
        panelClass: 'dialog',
        data: {
          CaseWorkItemID: this.currentCaseWorkItemID,
          CaseWorkItemFormID: this.currentCaseWorkItemFormID,
          enumFormCompletionStatus: EnumFormCompletionStatus,
          enumCaseWorkItemStatusID: EnumCaseWorkItemStatusID
        }
      });
      dialogRef.afterClosed().subscribe(result => {

        if (result === 'delete') {
          this.deleteSelectedItem();
        }
        else if (result === 'cancel') {
          this.cancelSelectedItem();
        }
        else {
          //
        }
      });
    }
  }

  /*openPerioCharting(){
    this.router.navigateByUrl('landing/perio');
  }*/

  deleteSelectedItem() {
    this.isLoading = true;
    // case item or form
    if (this.currentSelection === this.currentCaseWorkItemID) {
      // case work item selected
      this.caseService.deleteCaseWorkItem(this.currentCaseWorkItemID)
        .subscribe((response: any) => {
          this.loadData();
          this.showMessage('Success', 'Procedure deleted');
        }, err => {
          this.showMessage('Error', 'Problem deleting procedure');
        });
    }
    else if (this.currentSelection === this.currentCaseWorkItemFormID) {
      // case work item form selected
      this.caseService.deleteCaseWorkItemForm(this.currentCaseWorkItemFormID)
        .subscribe((response: any) => {
          this.caseService.deleteCaseWorkItemFormTeeth(this.currentCaseWorkItemFormID)
            .subscribe((response: any) => {
              this.loadData();
              //loaddata already reloads the forms
              //this.refreshPatientForms();
              this.showMessage('Success', 'Procedure form deleted');

            }, err => {
              this.showMessage('Error', 'Problem deleting procedure form');
            });
        }, err => {
          this.showMessage('Error', 'Problem deleting procedure form');
        });
    }
  }

  cancelSelectedItem() {
    this.isLoading = true;

    // case item or form
    if (this.currentSelection === this.currentCaseWorkItemID) {
      // case work item selected
      this.caseService.setCaseWorkItemToCanceled(this.currentCaseWorkItemID)
        .subscribe((response: any) => {
          this.loadData();
          this.showMessage('Success', 'Procedure canceled');
        }, err => {
          this.showMessage('Error', 'Problem canceling procedure');
        });
    }
    else if (this.currentSelection === this.currentCaseWorkItemFormID) {
      // case work item form selected
      this.caseService.setCaseWorkItemFormToCanceled(this.currentCaseWorkItemFormID)
        .subscribe((response: any) => {
          this.loadData();
          //loaddata already reloads the forms
          //this.refreshPatientForms();
          this.showMessage('Success', 'Procedure form canceled');
        }, err => {
          this.showMessage('Error', 'Problem canceling procedure form');
        });
    }
  }

  toggleMoreContent() {
    this.showMoreCaseOptions = !this.showMoreCaseOptions;
  }

  processMoreOptionsEvent(option) {

    this.showMoreCaseOptions = false;

    if (option === 0) {
      // show success
      this.closeCase();
    }

    if (option === 1) {
      // open Bill Functionality form
      this.openDialogCaseBillFunctionality();

    }

    if (option === 2) {
      // open Check out
      this.onCheckOutPatient();

    }
  }

  onCheckOutPatient() {
    this.schedulingService.getAppointmentIdByPatientId(this.globals.currentPatientId).subscribe({
      next: (dataC) => {
        this.appointment = dataC;
        if (!this.appointment) {
          return;
        }
        localStorage.setItem('selectedAppt', JSON.stringify(this.appointment));
        this.router.navigateByUrl('landing/notes-to-front');
        this.requestCheckOut.emit();
        this.caseService.stopAllTimerWatchByPatientCaseId(dataC.PatientCaseId).toPromise();
        this.messagingService.sendComponentMessage(MessagingConstants.CASES_REFRESH, {});
      },
      error: (error) => {
        console.error('getAppointmentIdByPatientId error:', error);
      }
    });
  }

  closeCase() {
    const payload = new CreateTransactionItemModel();
    payload.PatientId = this.globals.currentPatientId;
    payload.PatientCaseId = this.currentPatientCaseId;
    payload.LOCID = parseInt(localStorage.getItem('LOCID'));

    this.isLoading = true;
    this.arService.closeCase(payload)
      .subscribe((response: any) => {
        this.showMessage('Success', 'Case completed');
        this.loadData();
      }, err => {
        this.showMessage('Error', 'Problem completing case');
        this.isLoading = false;
      });
  }

  createTransactionForCase() {
    const payload = new CreateTransactionItemModel();
    payload.PatientId = this.globals.currentPatientId;
    payload.PatientCaseId = this.currentPatientCaseId;
    payload.LOCID = parseInt(localStorage.getItem('LOCID'));

    this.isLoading = true;
    this.arService.closeCase(payload)
      .subscribe((response: any) => {
        this.showMessage('Success', 'Case completed');

        // redirect to fees page
        this.isLoading = false;
        this.globals.currentPatientCaseId = this.currentPatientCaseId;
        this.router.navigateByUrl('/landing/fees');
      }, err => {
        this.showMessage('Error', 'Problem completing case');
        this.isLoading = false;
      });
  }

  showMessage(type, message) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

  openDialogAddProcedure(e) {
    // open a window to add a new procedure to this case
    const dialogRef = this.dialog.open(CaseAddProcedureComponent, {
      panelClass: 'dialog',
      data: {
        PatientCaseId: this.currentPatientCaseId,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined && result !== false)
        this.loadData();
    }, err => {
      this.loadData();
    });
  }

  openDialogCaseBillFunctionality() {
    // open a window to add a new procedure to this case
    const dialogRef = this.dialog.open(CaseBillFunctionalityComponent, {
      panelClass: 'dialog',
      data: {
        PatientCaseId: this.currentPatientCaseId,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined && result !== false)
        // close case, then send to fees page
        //this.createTransactionForCase();
        this.router.navigateByUrl('/landing/fees');
    }, err => {
      // close case, then send to fees page
      //this.createTransactionForCase();
      this.showMessage('Something went wrong', 'Error');
    });
  }

  async refreshPatientForms() {
    this.isLoadingPatientForms = true;
    this.caseWorkItemsPatientForms = [];
    // get current patient forms
    const promises: any[] = [
      this.caseService.getPatientForms(this.globals.currentPatientId).toPromise(), // general patient forms
    ];

    try {
      const results: any[] = await Promise.all(promises);

      if (results) {
        this.caseWorkItemsPatientForms = results[0];
        if (!this.caseWorkItemsPatientForms) {
          this.caseWorkItemsPatientForms = [];
        }
      }
      this.isLoadingPatientForms = false;
    } catch (err) {
      this.isLoading = false;
      this.showMessage('Error refreshing patient forms', 'Error');
    }
  }

  onFormItemClick(form: PatientCaseWorkItemFormDataModel, item: DataPatientCaseWorkItemModel) {
    this.currentSectionSelection = 1;
    if (form && (form.isToothRequired && form.dataPatientCaseItemFormTeeth.length === 0)) {
      this.dialogService.openToothPicker(false).subscribe((response) => {
        const teeth: cfgTooth[] = [];
        const toothUI: ToothUiManagerModel[] = response;
        toothUI.forEach(a => {
          teeth.push(a.toothModel);
        });

        // add selected teeth to newly added forms that need them
        // this.caseService.setCaseWorkItemFormTeeth(this.currentCaseWorkItemID, this.currentCaseWorkItemFormID, teeth)
        this.caseService.setCaseWorkItemFormTeeth(item.CaseWorkItemId, form.CaseWorkItemFormsId, teeth)
          .subscribe((response1) => {
            this.loadData();
            this.loadForm(form.CaseWorkItemFormsId, form.enumCustomFormID, form);
            this.currentCaseWorkItemFormID = form.CaseWorkItemFormsId;
            this.currentCaseWorkItemID = item.CaseWorkItemId;
            this.updateItemStatus();
            this.setCurrentSelections(item.CaseWorkItemId, form.CaseWorkItemFormsId, false);
            this.showMessage('Success', 'Teeth updated for form');
            for (const res of response) {
              const uiTooth = toothUI.find(p => p.toothModel.ToothId === res.ToothID);
              if (uiTooth) {
                this.caseService.saveCaseWorkItemTeethSurfaces(res.CaseWorkItemToothId, uiTooth.selectedSurfaceIds).subscribe((surfaceRes) => {
                  //
                });
              }
            }
            this.toothService.notifyToothChange();
          }, err => {
            this.showMessage('Error', 'Problem updating teeth for form');
          });

      }, err => {
        // this.loadData();
      });
    } else {
      this.loadForm(form.CaseWorkItemFormsId, form.enumCustomFormID, form);

      //if (this.currentCaseWorkItemFormID != form.CaseWorkItemFormsId && this.currentCaseWorkItemID != item.CaseWorkItemId) {
      this.currentCaseWorkItemFormID = form.CaseWorkItemFormsId;
      this.currentCaseWorkItemID = item.CaseWorkItemId;
      this.updateItemStatus();
      this.setCurrentSelections(item.CaseWorkItemId, form.CaseWorkItemFormsId, false);
      //}
    }
  }

  saveDoctorSelection(CaseWorkItemId, event) {
    alert('blah');
  }

  timerAction(WorkItemEventID: string, CaseWorkItemId: string, LOCID: number, start: boolean, stop: boolean) {
    const eventModel = new PassedPatientCaseWorkItemEventModel();
    eventModel.WorkItemEventID = WorkItemEventID;
    eventModel.CaseWorkItemID = CaseWorkItemId;
    eventModel.LOCID = LOCID;
    eventModel.StartTimer = start;
    eventModel.StopTimer = stop;
    const cwi = this.caseWorkItems.find(p => p.CaseWorkItemId === CaseWorkItemId);

    // if user is a dr, set dr
    if (this.userIsDoctor) {
      const userId = this.localStorageService.currentUserData.authdata.userid;
      const doctor = this.locationDoctors.find(a => a.UserId === userId);
      if (doctor) {
        if (cwi) {
          cwi.ProviderDoctorContactID = doctor.ContactId;
          cwi.ProviderDoctorID = doctor.DoctorId;
          // set dr object to cwi
          cwi.ProviderDoctor = doctor;

          this.localStorageService.practicingDoctorId = doctor.DoctorId;
          this.globals.currentProviderDoctorID = doctor.DoctorId;
          this.globals.currentProviderDoctorFullName = doctor.FullName;

        }
        eventModel.ProviderDoctorContactID = doctor.ContactId;
        eventModel.ProviderDoctorID = doctor.DoctorId;
      }
    } else {
      if (cwi.ProviderDoctorID) {
        const doc = this.locationDoctors.find(a => a.DoctorId === cwi.ProviderDoctorID);
        if (doc) {
          eventModel.ProviderDoctorContactID = doc.ContactId;
          eventModel.ProviderDoctorID = doc.DoctorId;
          if (cwi) {
            // set dr object to cwi
            cwi.ProviderDoctor = doc;
            this.localStorageService.practicingDoctorId = doc.DoctorId;
            this.globals.currentProviderDoctorID = doc.DoctorId;
            this.globals.currentProviderDoctorFullName = doc.FullName;
          }
        }
      }
      else {
        const doc = this.locationDoctors[0];
        if (doc) {
          eventModel.ProviderDoctorContactID = doc.ContactId;
          eventModel.ProviderDoctorID = doc.DoctorId;
          if (cwi) {
            // set dr object to cwi
            cwi.ProviderDoctor = doc;
          }
        }
      }
    }


    if (start) {
      this.schedulingService.SetSeatedStatus(cwi.PatientCaseId)
        .subscribe((surfaceRes) => {
          //
        });
    }

    // post obj
    this.caseService.handleCaseWorkItemEvent(eventModel)
      .subscribe((response: DataPatientCaseWorkItemEventModel) => {
        if (start) {
          this.showMessage('Success', 'Timer Started');
        }
        else if (stop) {
          this.showMessage('Success', 'Timer Stopped');
          this.globals.currentPatientCaseWorkItemEventID = '';
        }

        // update local case work item
        const CaseWorkItem = this.caseWorkItems.find(a => a.CaseWorkItemId === CaseWorkItemId);
        if (CaseWorkItem) {
          CaseWorkItem.EventDateStart = response.EventDateStart;
          CaseWorkItem.WorkItemEventID = response.WorkItemEventId;
          CaseWorkItem.ProviderDoctorContactID = eventModel?.ProviderDoctorContactID;
          this.localStorageService.practicingDoctorId = eventModel?.ProviderDoctorID;
          if (stop) {
            CaseWorkItem.EventDateStart = null;
            CaseWorkItem.WorkItemEventID = null;
            CaseWorkItem.ProviderDoctorContactID = null;
            this.localStorageService.practicingDoctorId = null;
          }
        }
        this.messagingService.sendComponentMessage(MessagingConstants.CASES_REFRESH, {});
      }, err => {
        this.showMessage('Error', 'There was an issue with the timer.');
      });
  }

  timerDoctorAction(WorkItemEventID: string, CaseWorkItemId: string, event: TdoDropdownChange) {
    if (event.isUserInput) {
      const CaseWorkItem = this.caseWorkItems.find(a => a.CaseWorkItemId === CaseWorkItemId);
      if (!event.value || (!event.isUserInput && CaseWorkItem.EventDateStart === null)) {
        return;
      }
      this.setActiveDoctor(event.value, WorkItemEventID, CaseWorkItem, true);
    }
  }

  private setActiveDoctor(providerDoctor: DoctorByTDOCIDModel, WorkItemEventID: string, CaseWorkItem: DataPatientCaseWorkItemModel, startTimer: boolean = false) {
    console.log('setActiveDoctor', providerDoctor);
    if (!providerDoctor) {
      console.log('no provider doctor');
      return;
    }
    this.localStorageService.practicingDoctorId = providerDoctor?.DoctorId;
    this.globals.currentProviderDoctorID = providerDoctor?.DoctorId;
    this.globals.currentProviderDoctorFullName = providerDoctor?.FullName;

    this.messagingService.sendComponentMessage(MessagingConstants.DOCTOR_UPDATE, { doctorId: providerDoctor?.DoctorId });

    // post obj
    if (startTimer) {
      const eventModel = new PassedPatientCaseWorkItemEventModel();
      eventModel.WorkItemEventID = WorkItemEventID;
      eventModel.CaseWorkItemID = CaseWorkItem.CaseWorkItemId;
      eventModel.LOCID = CaseWorkItem.LOCID;
      eventModel.ProviderDoctorContactID = providerDoctor?.ContactId;

      eventModel.StartTimer = false;
      eventModel.StopTimer = false;
      eventModel.ProviderDoctorID = providerDoctor?.DoctorId;
      this.caseService.handleCaseWorkItemEvent(eventModel)
        .subscribe((response: DataPatientCaseWorkItemEventModel) => {

          this.showMessage('Success', 'Doctor Selected');

          // update local case work item
          if (CaseWorkItem) {
            CaseWorkItem.WorkItemEventID = response.WorkItemEventId;
            CaseWorkItem.ProviderDoctorID = providerDoctor.DoctorId;
            CaseWorkItem.ProviderDoctorContactID = response?.ProviderDoctorContactID;
            CaseWorkItem.EventDateStart = response.EventDateStart;
            this.globals.currentProviderDoctorContactID = response?.ProviderDoctorContactID;
            this.globals.currentProviderDoctorID = providerDoctor.DoctorId;
            this.globals.currentProviderDoctorUserID = providerDoctor.UserId;
            this.globals.currentPatientCaseWorkItemEventID = response.WorkItemEventId;
          }

          this.messagingService.sendComponentMessage(MessagingConstants.CASES_REFRESH, {});

        }, err => {
          this.showMessage('Error', 'There was an issue with choosing the doctor.');
          console.log('Error: ', err);
        });
    }
  }

  returnLocationDoctorByContactID(contactID: string) {
    let returnContact: DoctorByTDOCIDModel = new DoctorByTDOCIDModel();

    if (this.locationDoctors && this.locationDoctors.length > 0) {
      returnContact = this.locationDoctors.find(a => a.ContactId === contactID);
      if (returnContact) {
        return returnContact;
      }
    }
    return null;
  }

  isCanEdit() {
    return this.authenticationService.currentUserRolesIds.includes(UserRoleEnum.CaseMgmt);
  }

  onShowAllEventsForWorkItem(item: DataPatientCaseWorkItemModel) {
    const config = new MatDialogConfig();
    config.panelClass = 'dialog';
    config.data = { doctors: this.doctorsByTDOCID, workItem: item, selectedProcedure: item  };

    this.dialog.open(CaseViewWorkItemEventsDialogComponent, config);
  }

  getFormEnumStatus(enumFormCompletionStatusID: string) {
    if (enumFormCompletionStatusID != null) {
      const enu = this.enumCaseItemFormStatus.find(p => p.ValidValueItemId.toLowerCase() === enumFormCompletionStatusID.toLowerCase());
      if (enu) {
        return enu.ItemDisplayValue;
      }
    }
    return '';
  }

  onPatientFormsDetails() {
    const config = new MatDialogConfig();
    config.panelClass = 'dialog';
    config.data = this.caseWorkItemsPatientForms;
    this.dialog.open(CaseViewPatientFormsDetailsDialogComponent, config);
  }

  onFormHeaderClick(form: PatientCaseWorkItemFormDataModel) {
    if (this.currentCaseWorkItemFormID != form.CaseWorkItemFormsId) {
      this.currentCaseWorkItemID = this.caseWorkItemsPatientFormsCaseWorkItemID;
      this.currentSectionSelection = 0;
      this.loadForm(form.CaseWorkItemFormsId, form.enumCustomFormID, form);
      this.currentCaseWorkItemFormID = form.CaseWorkItemFormsId;
      this.updateItemStatus();
      this.setCurrentSelections(this.caseWorkItemsPatientFormsCaseWorkItemID, form.CaseWorkItemFormsId)
    }
  }

  onClickCaseWorkItem(caseWorkItem: DataPatientCaseWorkItemModel) {
    if (this.currentCaseWorkItemID != caseWorkItem.CaseWorkItemId) {
      this.setCurrentSelections(caseWorkItem.CaseWorkItemId, '');
      this.currentSectionSelection = 1;
      if (caseWorkItem.ProviderDoctorID) {
        const doc = this.locationDoctors.find(a => a.DoctorId === caseWorkItem.ProviderDoctorID);
        if (doc) {
          caseWorkItem.ProviderDoctor = doc;
        }
        this.setActiveDoctor(caseWorkItem.ProviderDoctor, caseWorkItem.WorkItemEventID, caseWorkItem);
      }
    }
  }
}
